import { generateErrors } from 'utilities/util';
import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';
import { TYPES } from 'action-types/partners';
import { callApiV3Get } from 'utilities/apiCaller';
import API from 'constants/api';

export const fetchPartners = (type:number, valueId: number) => {
    return async (dispatch: ThunkDispatch<any, any, Action>) => {
        dispatch({ type: TYPES.FETCH_PARTNERS.PENDING });
        try {
            const res = await callApiV3Get(API.Partners.GetViewPartners, { 'SearchId': valueId, 'Level': type });
            // { headers: { TransportMode: 'Ocean' } }
            dispatch({ type: TYPES.FETCH_PARTNERS.FULFILLED, partners: res.data });
        } catch (e) {
            const errors = generateErrors(e);
            dispatch({ type: TYPES.FETCH_PARTNERS.REJECTED, errors });
        }
    }
};